export class StatusEventSearchStateObject {
    SearchStatusEventItems: StatusEventSearchItem[] = [];
    SelectedRows: StatusEventSearchItem[] = [];
    QueryParms: any;
}

export interface StatusEventSearchItem {
    StatusEventSubscriptionRunId: number;
    InterchangeInId: number;
    DocumentId: number | null;
    StatusEventSubscriptionDocumentStatusType: string;
    StatusEventSubscriptionName: string;
    StatusEventSubscriptionRunStatusType: string;
    DocumentStatusTriggerDate: Date;
    StatusEventSubscriptionRunLatestActivityDate: Date;
}

export interface StatusEventSearchLogItem {
    StatusEventSubscriptionStatusTypeName: string;
    Source: string;
    Comment: string;
    CreatedDate: Date;
}